export enum ChannelGenres {
    '对外渠道' = 1,
    '销售渠道' = 2
}
export enum ActionTypes {
    '品牌屏蔽',
    '特殊品牌开放',
    '电子券屏蔽',
    '电子券限制'
}
//模块
export enum Modules {
    '线上直充' = 1,
    '电子券',
    '甜蜜兑',
}